// extracted by mini-css-extract-plugin
module.exports = {"intro":"intro_intro__2DS9R","title":"intro_title__2RVuZ"};